<div class="overall">
  <app-complex-pie [pieData]="data" [colorScheme]="colorScheme" (onSelected)="getBucketBreakdown($event)">
  </app-complex-pie>
</div>
